import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import Routers from './router/router.js';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import axios from 'axios';
import Qs from 'qs'
import Vuex from 'vuex'
import './assets/css/style.css';
import globalData from './cfg.js'

Vue.prototype.$cfg = globalData;


Vue.use(VueRouter);
Vue.use(ViewUI);
Vue.prototype.$qs = Qs;
Vue.use(Vuex);


Vue.prototype.$http = axios.create({
	transformRequest: [(data)=> {
		if (typeof(data) == "string") data = data + '&auid=' + sessionStorage.getItem('uid')
		if (typeof(data) == "object"){
			data.auid = sessionStorage.getItem('uid');
			return Qs.stringify(data);
		}
		if (typeof(data) == 'undefined') data = 'auid=' + sessionStorage.getItem('uid')
		return data;
	}]
});


const RouterConfig = {
	esModule: false,
	mode: 'hash',
	routes: [{
			path: '/',
			component: (resolve) => require(['./pages/index.vue'], resolve),
			meta: {
				title: "车检宝管理系统",
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			children: [{
					path: '/client/config',
					component: (resolve) => require(['./pages/client/config.vue'], resolve),
					meta: {
						title: "小程序配置",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-1',
						nav: ['1']
					}
				},
				{
					path: '/client/user/list',
					component: (resolve) => require(['./pages/client/user/list.vue'], resolve),
					meta: {
						title: "会员管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-2',
						nav: ['1']
					}
				},
				{
					path: '/client/user/view/:id',
					component: (resolve) => require(['./pages/client/user/view.vue'], resolve),
					meta: {
						title: "查看会员信息",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-2',
						nav: ['1']
					}
				},
				{
					path: '/client/score/index',
					component: (resolve) => require(['./pages/client/score/index.vue'], resolve),
					meta: {
						title: "积分管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-5',
						nav: ['1']
					}
				},
				{
					path: '/client/score/list',
					component: (resolve) => require(['./pages/client/score/list.vue'], resolve),
					meta: {
						title: "积分明细",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-5',
						nav: ['1']
					}
				},
				{
					path: '/client/tg/list',
					component: (resolve) => require(['./pages/client/tg/list.vue'], resolve),
					meta: {
						title: "推广管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-3',
						nav: ['1']
					}
				},
				{
					path: '/client/tg/view/:id',
					component: (resolve) => require(['./pages/client/tg/view.vue'], resolve),
					meta: {
						title: "查看推广信息",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-3',
						nav: ['1']
					}
				},
				{
					path: '/client/tg/setting',
					component: (resolve) => require(['./pages/client/tg/setting.vue'], resolve),
					meta: {
						title: "推广设置",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-3',
						nav: ['1']
					}
				},
				{
					path: '/client/tx/list',
					component: (resolve) => require(['./pages/client/tx/list.vue'], resolve),
					meta: {
						title: "提现申请",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-4-1',
						nav: ['1', '1-4']
					}
				},
				{
					path: '/client/tx/view/:id',
					component: (resolve) => require(['./pages/client/tx/view.vue'], resolve),
					meta: {
						title: "查看提现申请",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-4-1',
						nav: ['1', '1-4']
					}
				},
				{
					path: '/client/tx/setting',
					component: (resolve) => require(['./pages/client/tx/setting.vue'], resolve),
					meta: {
						title: "提现设置",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-4-2',
						nav: ['1', '1-4']
					}
				},
				{
					path: '/client/page/list',
					component: (resolve) => require(['./pages/client/page/list.vue'], resolve),
					meta: {
						title: "页面管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-6',
						nav: ['1']
					}
				},
				{
					path: '/client/page/add',
					component: (resolve) => require(['./pages/client/page/add.vue'], resolve),
					meta: {
						title: "添加页面",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-6',
						nav: ['1']
					}
				},
				{
					path: '/client/page/modify/:id',
					component: (resolve) => require(['./pages/client/page/modify.vue'], resolve),
					meta: {
						title: "修改页面信息",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-6',
						nav: ['1']
					}
				},
				{
					path: '/client/activity/coupon/setting',
					component: (resolve) => require(['./pages/client/activity/coupon/setting.vue'], resolve),
					meta: {
						title: "活动设置",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-7-1-1',
						nav: ['1','1-7','1-7-1']
					}
				},
				{
					path: '/client/activity/coupon/log/list',
					component: (resolve) => require(['./pages/client/activity/coupon/log/list.vue'], resolve),
					meta: {
						title: "抢券记录",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '1-7-1-2',
						nav: ['1','1-7','1-7-1']
					}
				},
				{
					path: '/sf/config',
					component: (resolve) => require(['./pages/sf/config.vue'], resolve),
					meta: {
						title: "小程序配置",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '2-1',
						nav: ['2']
					}
				},
				{
					path: '/sf/user/list',
					component: (resolve) => require(['./pages/sf/user/list.vue'], resolve),
					meta: {
						title: "师傅管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '2-2',
						nav: ['2']
					}
				},
				{
					path: '/sf/user/view/:id',
					component: (resolve) => require(['./pages/sf/user/view.vue'], resolve),
					meta: {
						title: "师傅信息",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '2-2',
						nav: ['2']
					}
				},
				{
					path: 'order',
					component: (resolve) => require(['./pages/order/index.vue'], resolve),
					meta: {
						title: "概况",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '3-1',
						nav: ['3']
					}
				},
				{
					path: "order/setting",
					component: (resolve) => require(['./pages/order/setting.vue'], resolve),
					meta: {
						title: "订单设置",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '3-1',
						nav: ['3']
					}
				},
				{
					path: "order/list",
					component: (resolve) => require(['./pages/order/list.vue'], resolve),
					meta: {
						title: "订单管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '3-2',
						nav: ['3']
					}
				},
				{
					path: "order/coupon",
					component: (resolve) => require(['./pages/order/coupon/list.vue'], resolve),
					meta: {
						title: "优惠券管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '3-4',
						nav: ['3']
					}
				},
				{
					path: "order/view/:id",
					component: (resolve) => require(['./pages/order/view.vue'], resolve),
					meta: {
						title: "查看订单详情",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '3-2',
						nav: ['3']
					}
				},
				{
					path: "public/jcz/list",
					component: (resolve) => require(['./pages/public/jcz/list.vue'], resolve),
					meta: {
						title: "检测站管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '4-1',
						nav: ['4']
					}
				},
				{
					path: "admin/user/list",
					component: (resolve) => require(['./pages/admin/user/list.vue'], resolve),
					meta: {
						title: "管理员管理",
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						menu: '5-1',
						nav: ['5']
					}
				}
			]
		},
		{
			path: '/login',
			component: (resolve) => require(['./pages/login.vue'], resolve),
			meta: {
				title: "车检宝管理系统",
				requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
			}
		}
	]
};
const router = new VueRouter(RouterConfig);

Vue.config.productionTip = false


const ADD_COUNT = 'ADD_COUNT'; // 用常量代替事件类型，使得代码更清晰
const REMOVE_COUNT = 'REMOVE_COUNT';
//注册状态管理全局参数
const store = new Vuex.Store({
	state: {
		token: ''
	},
	mutations: {
		//写法与getters相类似
		//组件想要对于vuex 中的数据进行的处理
		//组件中采用this.$store.commit('方法名') 的方式调用，实现充分解耦
		//内部操作必须在此刻完成(同步)
		[ADD_COUNT](state, session) { // 第一个参数为 state 用于变更状态 登录
			sessionStorage.setItem("token", session.token);
			sessionStorage.setItem("uid", session.uid);
			state.token = session.token;
		},
		[REMOVE_COUNT](state, token) { // 退出登录
			sessionStorage.removeItem("token");
			sessionStorage.removeItem("uid");
			state.token = token;
		},
	}
});

router.beforeEach((to, from, next) => {
	ViewUI.LoadingBar.start(); //loadong 效果

	store.state.token = sessionStorage.getItem('token'); //获取本地存储的token

	if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
		if (store.state.token !== "" && store.state.token !== null) { // 通过vuex state获取当前的token是否存
			next();
		} else {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				} // 将跳转的路由path作为参数，登录成功后跳转到该路由
			})
		}
	} else {
		next();
	}
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
});

router.afterEach(route => {
	ViewUI.LoadingBar.finish();
});

const app = new Vue({
	router: router,
	store,
	mounted() {},
	render: h => h(App)
}).$mount('#app');
